module.exports = __webpack_public_path__ + "static/media/MENU_MOVIMIENTOS.f907567c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/MENU_MOVIMIENTOS.svg
// module id = 493
// module chunks = 0